export const PhoneIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1506 4949 c-62 -15 -153 -68 -197 -116 -22 -24 -55 -74 -72 -111
l-32 -67 0 -2096 0 -2095 37 -76 c45 -91 103 -147 196 -191 l67 -32 1055 0
1055 0 67 32 c93 44 151 100 196 191 l37 76 0 2096 0 2096 -37 76 c-45 91
-103 147 -196 191 l-67 32 -1035 2 c-604 1 -1051 -3 -1074 -8z m498 -257 c61
-121 107 -174 175 -197 66 -22 696 -22 762 0 68 23 114 76 175 197 l54 108
191 0 c121 0 207 -4 233 -12 55 -16 138 -99 154 -154 18 -60 18 -4088 0 -4148
-16 -55 -99 -138 -154 -154 -60 -17 -2008 -17 -2068 0 -55 16 -138 99 -154
154 -18 60 -18 4088 0 4148 15 51 99 137 148 153 20 6 119 11 232 12 l198 1
54 -108z"
      />
      <path
        d="M2105 615 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 l24 -25 431
0 431 0 24 25 c16 15 25 36 25 55 0 19 -9 40 -25 55 l-24 25 -431 0 -431 0
-24 -25z"
      />
    </g>
  </svg>
);
